// extracted by mini-css-extract-plugin
export const main = "colorfulText-module--main--1XNTX";
export const digits = "colorfulText-module--digits---1hcq";
export const keywords = "colorfulText-module--keywords--3P7uK";
export const names = "colorfulText-module--names--2Kqjp";
export const punctuation = "colorfulText-module--punctuation--1qsqp";